import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { useI18next } from "gatsby-plugin-react-i18next";

import "dayjs/locale/en";
import "dayjs/locale/es-mx";

// ********************************************************************************
// This component is used to provide the localization for the DatePicker components
// NOTE: This component is used in gatsby-browser.tsx as a wrapper for the entire 
// application.
export const DatePickerLocalizationProvider = ({ children }) => {
  const { language, t } = useI18next();

  return (
    <LocalizationProvider 
      dateAdapter={AdapterDayjs} 
      adapterLocale={language === "es" ? "es-mx"/*only on dayjs*/ : "en"}
      localeText={{ 
        okButtonLabel: t("ok"), 
        cancelButtonLabel: t("cancel"), 
        datePickerToolbarTitle: t("select_date"), 
        timePickerToolbarTitle: t("select_time") }}
      >
      {children}
    </LocalizationProvider>
  );
}